import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { Result } from '../../../common-models/Result';

export class GetCarrierDanfeLabelByOrdersInput {
  orderIds: number[];
}

export class GetCarrierDanfeLabelByOrdersOutput {
  orderLabels: CarrierDanfeOrderLabel[];
}

export class CarrierDanfeOrderLabel {
    orderId: number;
    label: string;
}

export class GetCarrierDanfeLabelByOrdersService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetCarrierDanfeLabelByOrdersInput): Promise<Result<GetCarrierDanfeLabelByOrdersOutput> | null> => {
    const promise = this.http.post<Result<GetCarrierDanfeLabelByOrdersOutput>, GetCarrierDanfeLabelByOrdersInput>(`${this.baseUrlSislogApi}/v2/danfe-packing-label/carrier-danfe-label`, input);
    return promise;
  }
}